import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletRial = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 14.9069,
	height: 9.97396,
	viewBox: "0 0 14.9069 9.97396",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Ø±ÛØ§Ù",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M12.0267 9.97396L11.7194 9.14583C12.5666 8.96181 13.1638 8.63889 13.511 8.17708C13.8582 7.71875 14.0319 7.17535 14.0319 6.54688C14.0319 6.25174 13.9989 5.94271 13.9329 5.61979C13.8704 5.2934 13.7819 4.96181 13.6673 4.625L14.5319 4.33333C14.7819 5.04514 14.9069 5.7309 14.9069 6.39063C14.9069 6.97049 14.8044 7.50694 14.5996 8C14.3982 8.49653 14.0839 8.91667 13.6569 9.26042C13.2332 9.60764 12.6898 9.84549 12.0267 9.97396Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M8.5577 6.22396H9.68791C10.0351 6.22396 10.2695 6.12326 10.391 5.92188C10.516 5.72049 10.5785 5.46528 10.5785 5.15625C10.5785 4.93056 10.5577 4.68924 10.516 4.43229C10.4744 4.17535 10.4292 3.91667 10.3806 3.65625L11.2869 3.42708C11.3459 3.70486 11.3928 3.97743 11.4275 4.24479C11.4622 4.51215 11.4796 4.76736 11.4796 5.01042C11.4796 5.42708 11.4223 5.79861 11.3077 6.125C11.1931 6.45139 11.0056 6.70833 10.7452 6.89583C10.4848 7.07986 10.1358 7.17188 9.69832 7.17188H8.5577V6.22396ZM10.4379 8L11.1671 8.72396L10.4379 9.45833L9.71395 8.72396L10.4379 8ZM8.70874 8L9.43791 8.72396L8.70874 9.45833L7.98478 8.72396L8.70874 8Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M6.89083 0H7.77104V4.97917C7.77104 5.46875 7.86131 5.79861 8.04187 5.96875C8.22243 6.13889 8.495 6.22396 8.85958 6.22396H8.98979V7.17188H8.85958C8.19638 7.17188 7.70159 6.99653 7.3752 6.64583C7.05229 6.29167 6.89083 5.73438 6.89083 4.97396V0Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M5.51563 6.56771C5.51563 7.66493 5.28125 8.47049 4.8125 8.98438C4.34375 9.49826 3.65972 9.75521 2.76042 9.75521C2.11458 9.75521 1.58854 9.63889 1.18229 9.40625C0.776042 9.17708 0.477431 8.8559 0.286458 8.44271C0.0954861 8.02951 0 7.55035 0 7.00521C0 6.63715 0.0381944 6.26042 0.114583 5.875C0.190972 5.48611 0.295139 5.10764 0.427083 4.73958L1.25521 5.07292C1.15451 5.39236 1.06944 5.72049 1 6.05729C0.930556 6.3941 0.895833 6.72049 0.895833 7.03646C0.895833 7.59896 1.03819 8.03646 1.32292 8.34896C1.61111 8.66146 2.09028 8.81771 2.76042 8.81771C3.38194 8.81771 3.84896 8.64757 4.16146 8.30729C4.47743 7.96701 4.63542 7.4184 4.63542 6.66146V0H5.51563V6.56771Z",
				fill: "#3C3C3C"
			})
		]
	})
});
export default SvgWalletRial;
